import React, { Component } from 'react';
import { Tooltip, Tabs, Modal } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import Container from '../../../../components/Container';
import ListPage from '../../../../components/ListPage';
import styles from './index.less';

const { ListTable, ListCreate } = ListPage;
const { TabPane } = Tabs;

@connect(({ messageList }) => ({
  ...messageList,
}))
class MessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      visible: false,
    };
  }

  componentDidMount() {
    this.setColumns();
    const { pageInfo, activeKey } = this.props;
    const { page, pageSize } = pageInfo;
    this.fetchList(page, pageSize, activeKey);
  }

  fetchList = (page, pageSize, msgStatus) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'messageList/fetchList',
      params: {
        page,
        pageSize,
        msgStatus,
      },
    });
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'msgTitle',
        key: 'msgTitle',
        fixed: 'left',
        width: 330,
        render: (text, record) => {
          if (!text) {
            return (
              <Tooltip placement="top" title={record.msgContent}>
                <span>
                  {text.length <= 20
                    ? record.msgContent
                    : `${record.msgContent.substring(0, 20)}...`}
                </span>
              </Tooltip>
            );
          }
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '发送人',
        dataIndex: 'authAuthor',
        key: 'authAuthor',
        width: 150,
      },
      {
        title: '发送应用',
        dataIndex: 'receiveAppName',
        key: 'receiveAppName',
        width: 150,
      },
      {
        title: '发送学校数',
        dataIndex: 'totalPushNum',
        key: 'totalPushNum',
        width: 150,
        render: text => {
          return <span>{text < 0 ? '-' : text}</span>;
        },
      },
      {
        title: '送达学校数',
        dataIndex: 'realityPushNum',
        key: 'realityPushNum',
        width: 150,
        render: text => {
          return <span>{text < 0 ? '-' : text}</span>;
        },
      },
      {
        title: '发送时间',
        dataIndex: 'startPushDate',
        key: 'startPushDate',
        render: text => {
          return <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>;
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 100,
        fixed: 'right',
        render: (text, record) => {
          if (record.msgStatus === '0') {
            return '-';
          }
          return (
            <a onClick={() => router.push(`/eduPush/list/analyze?groupId=${record.groupId}`)}>
              推送分析
            </a>
          );
        },
      },
    ];
    this.setState({ columns });
  };

  changeTab = activeKey => {
    const { dispatch } = this.props;
    dispatch({
      type: 'messageList/saveState',
      payload: {
        activeKey,
      },
    });
    this.fetchList(1, 10, activeKey);
  };

  onPageChange = (page, pageSize) => {
    const { activeKey } = this.props;
    this.fetchList(page, pageSize, activeKey);
  };

  handleGoToCreateOrEdit = type => {
    router.push(`/eduPush/list/create?msgType=${type}`);
  };

  render() {
    const { columns, visible } = this.state;
    const { spinProps, pageInfo, list, activeKey } = this.props;
    const pageProps = {
      spinProps,
      className: styles.root,
    };
    const tableProps = {
      pageInfo,
      columns,
      list,
      rowKey: 'id',
      onPageChange: this.onPageChange,
    };

    const createBtn = {
      btnText: '推送',
      onCreate: () => this.setState({ visible: true }),
    };

    return (
      <Container breStates={!0} version={2}>
        <ListPage {...pageProps}>
          <ListCreate {...createBtn} />
          <Tabs type="card" className="my-tabs" activeKey={activeKey} onChange={this.changeTab}>
            <TabPane tab="待发送" key="0" />
            <TabPane tab="发送中" key="1" />
            <TabPane tab="已发送" key="2" />
          </Tabs>
          <ListTable {...tableProps} />
        </ListPage>
        <Modal
          title="选择推送类型"
          centered
          className={styles['select-modal']}
          visible={visible}
          footer={[]}
          onCancel={() => this.setState({ visible: false })}
        >
          <div onClick={() => this.handleGoToCreateOrEdit('2')}>图文链接推送</div>
          <div onClick={() => this.handleGoToCreateOrEdit('3')}>文字推送</div>
        </Modal>
      </Container>
    );
  }
}

export default MessageList;
